import {
  ChangeDetectorRef,
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { PermissionService } from './permission.service';

@Directive({
  selector: '[appHasPermission]',
})
export class HasPermissionDirective {
  @Input() appHasPermission: string | string[] = '';

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionService: PermissionService,
    private cdr: ChangeDetectorRef
  ) {}

  async ngOnInit() {
    const permissions = Array.isArray(this.appHasPermission)
      ? this.appHasPermission
      : [this.appHasPermission];
    // console.log('Saint:', this.appHasPermission, permissions);
    const permissionsNegative = permissions
      .filter((permission) => permission.charAt(0) === '!')
      .map((permission) => permission.substring(1));
    const permissionsToCheck = permissions.filter(
      (permission) => permission.charAt(0) !== '!'
    );

    let hasPermission = undefined;
    if (permissionsToCheck.length > 0) {
      hasPermission = false;
      for (const permission of permissionsToCheck) {
        const permissionGranted = await this.hasPermiss(permission);
        if (permissionGranted) {
          hasPermission = true;
          break; // Si se concede uno de los permisos, ya no es necesario verificar los demás
        }
      }
    }

    let hasNegative = undefined;
    if (permissionsNegative.length > 0) {
      hasNegative = true;
      for (const permission of permissionsNegative) {
        const permissionGranted = await this.hasPermiss(permission);
        if (permissionGranted) {
          hasNegative = false;
          break; // Si se concede uno de los permisos, ya no es necesario verificar los demás
        }
      }
    }

    if (hasPermission || hasNegative) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.cdr.detectChanges();
    } else {
      this.viewContainer.clear();
    }
  }

  private async hasPermiss(permission: string): Promise<boolean> {
    return await this.permissionService.hasPermission(permission);
  }
}
